/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts

import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile/index";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ForgotPassword from "layouts/authentication/forgot-password";
import JobLists from "components/Joblistings/JobLists";
import MultiForm from "./layouts/multiForm/multiForm"
import Applications from "./components/MyApplications/myapplications";
import ReferFriend from "./layouts/referfriend";



// @mui icons
import Icon from "@mui/material/Icon";
import MyReferrals from "components/MyReferrals/myreferrals";
import MyReferrals1 from "components/MyReferrals/myreferrals1";
import MyReferrals2 from "components/MyReferrals/myreferrals2";
import JobLists1 from "components/Joblistings/JobList1";
import Applications1 from "components/MyApplications/myapplications1";
import Applications3 from "components/MyApplications/myapplication2";
import FamilyTree from "layouts/FamilyTree";
import JobListing from "layouts/JobListing";
// FamilyMemberDialog is now used within FamilyTree component, not as a standalone route
// import FamilyMemberDialog from "layouts/FamilyTree/FamilyMemberDialog";
import SampleTree from "layouts/FamilyTree/sampleTree";
import MasterData from "components/MasterData";
import Treeview from "layouts/Treeview";
import SharedProfilePage from "components/SharedProfilePage";



const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },
  {
    type: "collapse",
    name: "Master Data",
    key: "masterdata",
    icon: <Icon fontSize="small">storage</Icon>,
    route: "/masterdata",
    component: <MasterData />,
  },
  {
    type: "collapse",
    name: "Job Application",
    key: "jobApplication",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/jobApplication",
    component: <MultiForm />,
  },
  {
    type: "collapse",
    name: "Job Listing",
    key: "Job Listing",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/jobListing",
    component: <JobListing />,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },

  {
    type: "collapse",
    name: "Forgot Password",
    key: "forgot-password",
    icon: <Icon fontSize="small">lock_reset</Icon>,
    route: "/authentication/forgot-password",
    component: <ForgotPassword />,
  },

  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "MyApplication",
    key: "MyApplication",
    icon: <Icon fontSize="small">App</Icon>,
    route: "/myApplication",
    component: <Applications />,
  },
  {
    type: "collapse",
    name: "MyApplication2",
    key: "MyApplication2",
    icon: <Icon fontSize="small">App</Icon>,
    route: "/myApplication2",
    component: <Applications1 />,
  },
  {
    type: "collapse",
    name: "MyApplication3",
    key: "MyApplication3",
    icon: <Icon fontSize="small">App</Icon>,
    route: "/myApplication3",
    component: <Applications3 />,
  },
  {
    type: "collapse",
    name: "MyReferral",
    key: "MyReferral",
    icon: <Icon fontSize="small">Edit</Icon>,
    route: "/myReferral",
    component: <MyReferrals />,
  },
  {
    type: "collapse",
    name: "MyReferral2",
    key: "MyReferral2",
    icon: <Icon fontSize="small">Edit</Icon>,
    route: "/myReferral2",
    component: <MyReferrals1 />,
  },
  {
    type: "collapse",
    name: "MyReferral3",
    key: "MyReferral3",
    icon: <Icon fontSize="small">Edit</Icon>,
    route: "/myReferral3",
    component: <MyReferrals2 />,
  },
  {
    type: "collapse",
    name: "Joblist2",
    key: "Joblist2",
    icon: <Icon fontSize="small">Edit</Icon>,
    route: "/joblist2",
    component: <JobLists1 />,
  },
  {
    type: "collapse",
    name: "ReferFriend",
    key: "ReferFriend",
    icon: <Icon fontSize="small">Edit</Icon>,
    route: "/referfriend",
    component: <ReferFriend />,
  },
  {
    type: "collapse",
    name: "Family Tree",
    key: "familyTree",
    icon: <Icon fontSize="small">Edit</Icon>,
    route: "/familyTree",
    component: <FamilyTree />,
  },
  // Note: AddFamily route removed - use FamilyTree component which has integrated add/edit functionality
  // {
  //   type: "collapse",
  //   name: " AddFamily Tree",
  //   key: "addFamilyTree",
  //   icon: <Icon fontSize="small">Edit</Icon>,
  //   route: "/addFamilyTree",
  //   component: <FamilyMemberDialog mode="add" />,
  // },
  {
    type: "collapse",
    name: " Sample",
    key: "Sample",
    icon: <Icon fontSize="small">Edit</Icon>,
    route: "/SampleTree",
    component: <SampleTree />,
  },
  {
    type: "collapse",
    name: "Business Tree",
    key: "businessTree",
    icon: <Icon fontSize="small">account_tree</Icon>,
    route: "/treeview",
    component: <Treeview />,
  },
  {
    route: "/share/:token",
    component: <SharedProfilePage />,
    public: true, // Mark as public route
    key: "share-profile"
  }
];

export default routes;
